<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
    >
      
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "perno",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("EntryDate"),
          value: "beginDate",
        },
        {
          text: this.$t("EntryTime"),
          value: "beginTime",
        },
        {
          text: this.$t("ExitTime"),
          value: "endTime",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>